import { useKeycloak } from "@react-keycloak/web";
import React, { createContext, useEffect, useState } from "react";
import useLandingAuthApi from "./api/useLandingAuthApi";
import ErrorPopup from "../components/elements/ErrorPopup";

const StorageContext = createContext();

const StorageProvider = ({ children }) => {
  const { keycloak } = useKeycloak();
  const { fetchListOfAirport } = useLandingAuthApi();
  const [airportData, setAirportData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (keycloak.authenticated && !airportData) {
      fetchListOfAirport()
        .then((data) => {
          return setAirportData(data);
        })
        .catch((err) => setError(err));
    }
  }, [fetchListOfAirport, keycloak.authenticated]);

  if (error) {
    return <ErrorPopup children={error.message}></ErrorPopup>;
  }

  return (
    <StorageContext.Provider
      value={{
        airportData,
      }}
    >
      {children}
    </StorageContext.Provider>
  );
};

export { StorageContext, StorageProvider };
